import GalleryElement from '../GalleryElement/GalleryElement';
import MobileGalleryElementDefinition from './MobileGalleryElementDefinition';
import MobileGalleryElementMetaData from './MobileGalleryElementMetaData';

export default {
  MobileGalleryElement: GalleryElement,
  MobileGalleryElementDefinition: MobileGalleryElementDefinition,
  MobileGalleryElementType: MobileGalleryElementMetaData.type
};
